var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94212 3.18412L5.27653 7.25451M5.27653 7.25451L5.18006 11.2455M5.27653 7.25451L1 10.3321M5.27653 7.25451L9.44051 7.53249M5.27653 7.25451L7.59164 1M5.27653 7.25451L11 10.5108M5.27653 7.25451L3.00965 11.5235M5.27653 7.25451L1.209 3.46209M5.27653 7.25451L9.18328 4.31588M5.27653 7.25451L1.75563 6.91697M5.27653 7.25451L7.59164 12",
    stroke: "#8A2BE2",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndline);
export default __webpack_public_path__ + "static/media/endline.cb645ce689ee9a2e52d205fddf9fcc8a.svg";
export { ForwardRef as ReactComponent };